// extracted by mini-css-extract-plugin
module.exports = {"shadow":"ClickableLink_shadow__1maxx","link":"ClickableLink_link__1JoG1"};